// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"107":"0332a106f0966571","389":"ce700919b51ef1af","483":"c8ad4fa7b1b47c2b","944":"14fd4fde7d376498"}[chunkId] + ".js";
};